// * ========================================================================
// * video banner - HTML5 events
// * ========================================================================

'use strict';

import $ from 'jquery'; //npm package


var bannerVideo = (function() {

  function videoClose(video) {
    video.load(); //or video.pause
    video.removeAttribute('controls');
  }

  function videoShow(video) {
    video.play();
    video.setAttribute('controls','controls');
  }

  function init() {

    let videoList = document.getElementsByTagName('video');

    for(let video of videoList){
      video.load();
      //hide controls for now
      video.removeAttribute('controls');

      video.addEventListener('canplay', function(){
        $('.video-banner__play').on('click', '', function(e){
          const videoElements = this.nextElementSibling.children;
          let targetVideo = videoElements.namedItem('bannervideo');

          let closeButton = videoElements.item(0); //close button
          $(this).hide();
          $(closeButton).show();
          videoShow(targetVideo);
        });

        $('.video-banner .close').on('click', '', function(e){
          e.preventDefault();
          const videoElements = this.parentElement.children;
          const playButton = this.parentElement.previousElementSibling;
          let targetVideo = videoElements.namedItem('bannervideo');

          videoClose(targetVideo);
          $(playButton).show();
          $(this).hide();
        });
      });
    }
  }

  return {
    init: init
  };

})();

export default bannerVideo;
